export const fetchDatabase = async (url: string, signal?: AbortSignal) => {
    const resp = await fetch(url, {
        signal,
    });
    const data = await resp.arrayBuffer();
    return new Uint8Array(data);
};
